import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

import { AdfoxCloseButtonColor, AdfoxCtaButtonStyle } from 'components/Admin/AdfoxInfo/adfoxInfoModel';
import { CloseButtonPreview } from 'components/Admin/AdfoxInfo/PromoFields/FullScreenStyleFields/CloseButtonPreview/CloseButtonPreview';
import { CtaButtonPreview } from 'components/Admin/AdfoxInfo/PromoFields/FullScreenStyleFields/CtaButtonPreview/CtaButtonPreview';
import { RadioGroup } from 'components/Admin/AdfoxInfo/RadioGroup/RadioGroup';

import { updateAdfoxInfoForm } from 'store/models/adfoxInfo';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    ctaButtonStyleTitle: 'admin.adfoxInfo.ctaButtonStyle.title',
    ctaButtonStyle: {
        [AdfoxCtaButtonStyle.Accent]: 'admin.adfoxInfo.ctaButtonStyle.accent',
        [AdfoxCtaButtonStyle.Contrast]: 'admin.adfoxInfo.ctaButtonStyle.contrast',
        [AdfoxCtaButtonStyle.Neutral]: 'admin.adfoxInfo.ctaButtonStyle.neutral',
    },
    closeButtonColorTitle: 'admin.adfoxInfo.closeButtonColor.title',
    closeButtonColor: {
        [AdfoxCloseButtonColor.Dark]: 'admin.adfoxInfo.closeButtonColor.dark',
        [AdfoxCloseButtonColor.Light]: 'admin.adfoxInfo.closeButtonColor.light',
    },
};

export const FullScreenStyleFields: FC = () => {
    const ctaButtonStyle = useSelector((state) => state.adfoxInfo.ctaButtonStyle);
    const closeButtonColor = useSelector((state) => state.adfoxInfo.closeButtonColor);

    const trls = useTrls();
    const dispatch = useDispatch();

    return (
        <>
            <RadioGroup
                title={trls(TrlKeys.ctaButtonStyleTitle)}
                name="adfox-info-cta-style"
                options={[AdfoxCtaButtonStyle.Accent, AdfoxCtaButtonStyle.Contrast, AdfoxCtaButtonStyle.Neutral]}
                value={ctaButtonStyle}
                labels={TrlKeys.ctaButtonStyle}
                dataQaPrefix="adfox-info-cta-style"
                renderPreview={(option) => <CtaButtonPreview option={option} />}
                onChange={(value) => dispatch(updateAdfoxInfoForm({ ctaButtonStyle: value }))}
            />
            <RadioGroup
                title={trls(TrlKeys.closeButtonColorTitle)}
                name="adfox-info-close-color"
                options={[AdfoxCloseButtonColor.Dark, AdfoxCloseButtonColor.Light]}
                value={closeButtonColor}
                labels={TrlKeys.closeButtonColor}
                dataQaPrefix="adfox-info-close-color"
                renderPreview={(option) => <CloseButtonPreview option={option} />}
                onChange={(value) => dispatch(updateAdfoxInfoForm({ closeButtonColor: value }))}
            />
        </>
    );
};
